import { LayerTypeDTO } from 'business/models/Models';
import { LabelRadioBox } from 'components/customComponents/Layers/InputGroups';
import { Table } from 'components/main/ProteinFormulation/ProteinIngredients';
import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import './optimization.scss';
import { OptimizationContext } from './OptimizationContext';
import GridExample from 'Icons/Optimization/GridExample.png';
import IterativeExample from 'Icons/Optimization/IterativeExample.png';
import RandomExample from 'Icons/Optimization/RandomExample.png';
import { padZeros } from 'utils/Global';
import { CheckBoxRow, OptimizationText, OptTextVariants } from './OptimizationComponents';
import InfoIcon from 'Icons/Optimization/Info.png';

const OptimizationSelectLayer = () => {
  const context = useContext(OptimizationContext);
  function getTableData() {
    if (context.layerType === LayerTypeDTO.Screen) {
      return context.isoPrecipitantIngs.map((ing) => {
        return { ing: ing.name, stock: `Stock ${padZeros(ing.stockNumber, 3)}` };
      });
    } else {
      return context.selectedWellsIngredientData.map((ing) => {
        return { ing: ing.name, stock: `Stock ${padZeros(ing.stockNumber, 3)}` };
      });
    }
  }

  function getOptimizationText() {
    if (context.layerType === LayerTypeDTO.Grid) {
      return 'Grid layers allow you to vary the concentrations and pH levels of ingredients in incremental steps along the rows and columns of a layer, as well as from one layer to another through the use of sub-layers.';
    } else if (context.layerType === LayerTypeDTO.Random) {
      return 'ROCK MAKER dispenses each well and its drops using ingredients randomly selected from among those you have chosen to include in the experiment.';
    } else if (context.layerType === LayerTypeDTO.ConditionList) {
      return 'ROCK MAKER allows you to create a new Custom Layer with selected Conditions to include in the new experiment.';
    } else if (context.layerType === LayerTypeDTO.Screen) {
      return 'ROCK MAKER enables you to create an ISO experiment, which allows you to optimize a previous experiment by adjusting the concentration of the precipitate in each well.';
    }
  }

  return (
    <>
      <Row id="optimizationselectlayer-row-title" className="h-10">
        <Col id="optimizationselectlayer-col-title"
          style={{
            textAlign: 'center',
            fontFamily: 'Arial',
            fontWeight: 700,
            fontSize: '18px',
          }}
        >
          Welcome to Optimization Wizard
        </Col>
      </Row>
      <Row id="optimizationselectlayer-row-content" className="h-90">
        <Col id="optimizationselectlayer-col-content-wrapper"
          style={{
            height: '100%',
            margin: '1rem',
            marginLeft: '6rem',
            marginRight: '6rem',
          }}
        >
          <div id="optimizationselectlayer-main-container"
            style={{
              padding: '0.5rem',
              height: '100%',
              border: '1px dashed black',
              display: 'flex',
            }}
          >
            <div id="optimizationselectlayer-leftpanel"
              style={{ height: '100%', flex: '50%', borderRight: '1px solid #C2C2C2' }}
            >
              <OptimizationText text="Optimize Layer" variant={OptTextVariants.heading} />
              <div id="optimizationselectlayer-leftpanel-content" style={{ margin: '1rem', marginTop: '0rem' }}>
                <OptimizationText  text={'How Would you like to optimize?'} />
                <Row id="optimizationselectlayer-row-radio-1" className="mt-2">
                  <Col id="optimizationselectlayer-col-radio-1" md="6">
                    <LabelRadioBox
                      style={{ height: '30px', justifyContent: 'flex-start' }}
                      labelText={'In a Grid Layer'}
                      radioValue={context.layerType == LayerTypeDTO.Grid}
                      onChange={() => context.setLayerType(LayerTypeDTO.Grid)}
                      name="layerType"
                      disabled={false}
                    />
                  </Col>
                  <Col>
                    <LabelRadioBox
                      style={{ height: '30px', justifyContent: 'flex-start' }}
                      labelText={'In a Random Layer'}
                      radioValue={context.layerType == LayerTypeDTO.Random}
                      onChange={() => context.setLayerType(LayerTypeDTO.Random)}
                      name="layerType"
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row  id="optimizationselectlayer-row-radio-2">
                  <Col  id="optimizationselectlayer-col-radio-2" md="6">
                    <LabelRadioBox
                      style={{ height: '30px', justifyContent: 'flex-start' }}
                      labelText={'In a Custom Layer'}
                      radioValue={context.layerType == LayerTypeDTO.ConditionList}
                      onChange={() => context.setLayerType(LayerTypeDTO.ConditionList)}
                      name="layerType"
                      disabled={false}
                    />
                  </Col>
                  <Col>
                    <LabelRadioBox
                      style={{ height: '30px', justifyContent: 'flex-start' }}
                      labelText={'In an Iterative Screen'}
                      radioValue={context.layerType == LayerTypeDTO.Screen}
                      onChange={() => context.setLayerType(LayerTypeDTO.Screen)}
                      name="layerType"
                      disabled={context.isoDisabled}
                    />
                  </Col>
                </Row>
                <Row id="optimizationselectlayer-row-info"
                  style={{
                    fontSize: '13px',
                    fontWeight: 400,
                    lineHeight: '1.5rem',
                    marginTop: '0.85rem',
                    height: '5rem',
                  }}
                >
                  <Col id="optimizationselectlayer-info-icon-col" md="1">
                    <img id="optimizationselectlayer-info-icon" src={InfoIcon} />
                  </Col>
                  <Col id="optimizationselectlayer-info-text" md="11">{getOptimizationText()}</Col>
                </Row>
                <div id="optimizationselectlayer-optimizeexample-label" style={{ height: 34, fontSize: 13, marginTop: '1rem' }}>
                  Optimize Example
                </div>
                <Row id="optimizationselectlayer-optimizeexample-row">
                  <Col id="optimizationselectlayer-optimizeexample-col">
                    <div id="optimizationselectlayer-optimizeexample-container"
                      style={{ display: 'flex', flexDirection: 'column', width: '90%' }}
                    > 
                      <div id="optimizationselectlayer-optimizeexample-header" style={{ display: 'flex', height: '19px', width: '70%' }}>
                        <div id="optimizationselectlayer-optimizeexample-typebox"
                          style={{
                            height: '100%',
                            width: '100px',
                            background: '#C4C4C4',
                            border: '2px solid #707070',
                            borderBottom: 'none',
                            marginBottom: '0rem',
                            paddingLeft: '0.25rem',
                            paddingRight: '0.25rem',
                            fontSize: '10px',
                            lineHeight: '17px',
                          }}
                        >
                          {context.layerType == LayerTypeDTO.Grid
                            ? 'Grid Layer'
                            : context.layerType == LayerTypeDTO.Random
                            ? 'Random Layer'
                            : context.layerType == LayerTypeDTO.ConditionList
                            ? 'Custom Layer'
                            : 'Screen Layer'}
                        </div>
                        <div id="optimizationselectlayer-optimizeexample-typebox-line"
                          style={{ borderBottom: '2px solid #707070' }}
                          className="optimization-type-img-text"
                        ></div>
                      </div>
                      <img id="optimizationselectlayer-optimizeexample-image"
                        style={{
                          width: '70%',
                          height: '12.4rem',
                          border: '2px solid #707070',
                          borderTop: 'none',
                        }}
                        src={
                          context.layerType == LayerTypeDTO.Grid
                            ? GridExample
                            : context.layerType == LayerTypeDTO.Random ||
                              context.layerType == LayerTypeDTO.ConditionList
                            ? RandomExample
                            : IterativeExample
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div id="optimizationselectlayer-rightpanel" style={{ paddingLeft: '1rem', height: '100%', flex: '50%' }}>
              <OptimizationText text="Ingredient" variant={OptTextVariants.heading} />
              <div id="optimizationselectlayer-ingredient-container" style={{ height: '90%' }}>
                <CheckBoxRow
                  isChecked={context.substituteStock}
                  onChange={() => context.setSubstituteStock(!context.substituteStock)}
                  label="Substitute Source Stocks with Prepared Ones"
                />
                <div id="optimizationselectlayer-ingredient-tablecontainer" style={{ height: '80%', marginBottom: '2rem', overflow: 'auto' }}>
                  <Table 
                    columns={[
                      { Header: 'Ingredient', accessor: 'ing', width: '70%' },
                      { Header: 'Stock', accessor: 'stock', width: '30%' },
                    ]}
                    data={getTableData()}
                    classNames="optimization"
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OptimizationSelectLayer;
